import {StyleSheet} from "aphrodite";

import {border} from "@khanacademy/wonder-blocks-tokens";
import {Body} from "@khanacademy/wonder-blocks-typography";

import type {JsonPath} from "../../types.ts";
import EditableItem from "../editable-item.tsx";
import InlineMarkdown from "../inline-markdown.tsx";

export default function ParagraphNode(props: {text: string; path: JsonPath}) {
    const {text, path} = props;

    return (
        <EditableItem path={path}>
            <Body tag="p" style={styles.p}>
                <InlineMarkdown text={text} />
            </Body>
        </EditableItem>
    );
}

const styles = StyleSheet.create({
    p: {
        marginBlockStart: 0,
        marginBlockEnd: 0,
        borderRadius: border.radius.radius_040,
        fontWeight: "inherit",
    },
});
